class PriceService {

    static getFormattedPrice(price) {
        return Number((Math.round(price * 100 + Number.EPSILON) / 100).toFixed(2));
    }
}

export default PriceService;
